const animations = [
    { value: null, label: 'none' },
    { value: 'bounce', label: 'Bounce' },
    { value: 'flash', label: 'Flash' },
    { value: 'pulse', label: 'Pulse' },
    { value: 'rubberBand', label: 'Rubber Band' },
    { value: 'shake', label: 'Shake' },
    { value: 'headShake', label: 'Head Shake' },
    { value: 'swing', label: 'Swing' },
    { value: 'tada', label: 'Tada' },
    { value: 'wobble', label: 'Wobble' },
    { value: 'jello', label: 'Jello' },
    { value: 'bounceIn', label: 'Bounce In' },
    { value: 'bounceInDown', label: 'Bounce In Down' },
    { value: 'bounceInLeft', label: 'Bounce In Left' },
    { value: 'bounceInRight', label: 'Bounce In Right' },
    { value: 'bounceInUp', label: 'Bounce In Up' },
    { value: 'fadeIn', label: 'Fade In' },
    { value: 'fadeInDown', label: 'Fade In Down' },
    { value: 'fadeInDownBig', label: 'Fade In Down Big' },
    { value: 'fadeInLeft', label: 'Fade In Left' },
    { value: 'fadeInLeftBig', label: 'Fade In Left Big' },
    { value: 'fadeInRight', label: 'Fade In Right' },
    { value: 'fadeInRightBig', label: 'Fade In Right Big' },
    { value: 'fadeInUp', label: 'Fade In Up' },
    { value: 'fadeInUpBig', label: 'Fade In Up Big' },
    { value: 'flipInX', label: 'Flip In X' },
    { value: 'flipInY', label: 'Flip In Y' },
    { value: 'rotateIn', label: 'Rotate In' },
    { value: 'rotateInDownLeft', label: 'Rotate In Down Left' },
    { value: 'rotateInDownRight', label: 'Rotate In Down Right' },
    { value: 'rotateInUpLeft', label: 'Rotate In Up Left' },
    { value: 'rotateInUpRight', label: 'Rotate In Up Right' },
    { value: 'hinge', label: 'Hinge' },
    { value: 'jackInTheBox', label: 'Jack In The Box' },
    { value: 'rollIn', label: 'Roll In' },
    { value: 'zoomIn', label: 'Zoom In' },
    { value: 'zoomInDown', label: 'Zoom In Down' },
    { value: 'zoomInLeft', label: 'Zoom In Left' },
    { value: 'zoomInRight', label: 'Zoom In Right' },
    { value: 'zoomInUp', label: 'Zoom In Up' },
    { value: 'slideInDown', label: 'Slide In Down' },
    { value: 'slideInLeft', label: 'Slide In Left' },
    { value: 'slideInRight', label: 'Slide In Right' },
    { value: 'slideInUp', label: 'Slide In Up' },
]

export default animations;